module.exports = __webpack_public_path__ + "static/media/production_comparative_per_subpark.b9263824.svg";